<template>
    <div class="popup-modal-container">
        <div class="popup-modal">
            <div class="popup-modal-content">
                <slot></slot>
            </div>
            <button @click="handleSetActionEmit" class="set-action">Set</button>
            <button @click="handleCancelActionEmit" class="cancel-action">Cancel</button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'PopupModal',
        emits: ['setAction', 'cancelAction'],

        methods: {
            handleSetActionEmit() {
                this.$emit('setAction')
            },

            handleCancelActionEmit() {
                this.$emit('cancelAction')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .popup-modal-container {
        display: flex;
        justify-content: center;
        align-items: center;

        .invalid-input {
            border: 1px solid #dc3545 !important;
        }

        .input-err-msg {
            color: #dc3545;
            margin-bottom: 10px;
            margin-left: 5px;
        }

        .popup-modal {
            min-width: 1160px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 15px;
            background: #262626;

            .popup-modal-content {
                width: 100%;
            }

            .set-action {
                margin-top: 73px;
                min-width: 600px;
                padding: 11px 30px 12px 30px;
                border-radius: 100px;
                background: #cdeb09;
                color: black;
                font-size: 18px;
                font-family: Instrument Sans;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
            }

            .cancel-action {
                margin-top: 25px;
                margin-bottom: 50px;
                min-width: 600px;
                border: none;
                background: transparent;
                color: #8b8b8b;
                font-size: 18px;
                font-family: Studio Pro;
                font-style: normal;
                font-weight: 600;
                line-height: 120%;
                text-decoration-line: underline;
            }
        }
    }
</style>
